function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "grd1",
  gradientUnits: "userSpaceOnUse",
  x1: 161.01,
  y1: 40.008,
  x2: 101.01,
  y2: 180
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#424d58"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272a2f"
})));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: url(#grd1) } \n\t\t.shp1 { fill: #ffffff } \n\t");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "shp0",
  d: "M121 240C54.64 240 1 186.36 1 120C1 53.64 54.64 0 121 0C187.36 0 241 53.64 241 120C241 186.36 187.36 240 121 240Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Layer",
  className: "shp1",
  d: "M50.94 118.96L131.75 85.66C139.73 82.2 166.78 71.1 166.78 71.1C166.78 71.1 179.27 66.24 178.23 78.03C177.88 82.89 175.11 99.88 172.33 118.26L163.66 172.71C163.66 172.71 162.97 180.69 157.06 182.08C151.16 183.47 141.45 177.22 139.72 175.84C138.33 174.8 113.71 159.19 104.69 151.56C102.26 149.48 99.49 145.32 105.04 140.46C117.52 129.02 132.44 114.8 141.45 105.78C145.62 101.62 149.78 91.91 132.44 103.7L83.54 136.65C83.54 136.65 77.99 140.11 67.58 136.99C57.18 133.87 45.04 129.71 45.04 129.71C45.04 129.71 36.71 124.51 50.93 118.96L50.94 118.96Z"
});

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 241 240",
    width: 241,
    height: 220,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.06bfd4f5.svg";
export { ForwardRef as ReactComponent };